import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content/evaluation")({
  component: () => (
    <Breadcrumb label="Evaluation" to="/content/evaluation">
      <Outlet />
    </Breadcrumb>
  ),
});
